const PlayerTableBet = ({ bets = {} }) => {
  if (!bets.score || !bets.score.last) return '-';

  return bets.score.last;
};

export default PlayerTableBet;
